import { Box, Divider, Text } from '@wix/design-system';
import type { FC } from 'react';
import React, { useContext } from 'react';

import { RicosContext } from './../../../../../ricos-context';
import { PREDEFINED_SWATCH_COLORS } from './../../../../../plugin-button/defaults';
import { removeColorDuplicates } from './../../../../color-picker/new-color-picker/components/swatch-color-picker/utils';

import { CUSTOM_SWATCHES, PREDEFINED_SWATCHES, THEME_SWATCHES } from '../../data-hooks';
import { NewColorSwatches } from '../new-color-swatches';
import classes from './swatch-color-picker-scss';

type SwatchColorPickerProps = {
  currentColor: string | undefined;
  themeColors: string[];
  customColors: string[];
  onAddClick: () => void;
  onColorSelected: (color: string | undefined) => void;
  onColorPreviewStart?: (color: string | undefined) => void;
  onColorPreviewEnd?: () => void;
  setAddButtonRef?: (ref: HTMLDivElement) => void;
};

export const SwatchColorPicker: FC<SwatchColorPickerProps> = ({
  currentColor,
  themeColors: themeColorsProp,
  customColors: customColorsProp,
  onAddClick,
  onColorSelected,
  onColorPreviewStart,
  onColorPreviewEnd,
  setAddButtonRef,
}) => {
  const { t } = useContext(RicosContext);

  const { themeColors, customColors } = removeColorDuplicates(themeColorsProp, customColorsProp);

  return (
    <div className={classes.content}>
      {themeColors.length > 0 && (
        <>
          <Box direction="vertical" padding="SP3" gap="SP3">
            <Text size="small" weight="bold">
              {t('Color_Picker_ThemeColor_Title')}
            </Text>
            <NewColorSwatches
              colors={themeColors}
              selectedColor={currentColor?.toUpperCase()}
              onColorSelected={onColorSelected}
              onColorPreviewStart={onColorPreviewStart}
              onColorPreviewEnd={onColorPreviewEnd}
              dataHook={THEME_SWATCHES}
            />
          </Box>
          <Divider />
        </>
      )}
      <Box direction="vertical" padding="SP3" gap="SP3">
        <Text size="small" weight="bold">
          {t('Color_Picker_CustomColor_Title')}
        </Text>
        <Box direction="vertical" gap="SP2">
          <NewColorSwatches
            colors={PREDEFINED_SWATCH_COLORS}
            selectedColor={currentColor?.toUpperCase()}
            onColorSelected={onColorSelected}
            onColorPreviewStart={onColorPreviewStart}
            onColorPreviewEnd={onColorPreviewEnd}
            dataHook={PREDEFINED_SWATCHES}
          />
          <NewColorSwatches
            colors={customColors}
            onAddClick={onAddClick}
            setAddButtonRef={setAddButtonRef}
            selectedColor={currentColor?.toUpperCase()}
            onColorSelected={onColorSelected}
            onColorPreviewStart={onColorPreviewStart}
            onColorPreviewEnd={onColorPreviewEnd}
            dataHook={CUSTOM_SWATCHES}
          />
        </Box>
      </Box>
    </div>
  );
};
